// extracted by mini-css-extract-plugin
module.exports = {"searchContainer":"search_searchContainer__lWZXq","searchIcon":"search_searchIcon__3YJBs"};